// extracted by mini-css-extract-plugin
module.exports = {"feedbackBar":"AIFeedbackBar_feedbackBar__EF4Nd","btn":"AIFeedbackBar_btn__-ombs","loading":"AIFeedbackBar_loading__1lLaX"};